import React, { useEffect, useState } from 'react';
import { Container, IconButton, Table, Tag, Loader, Pagination } from 'rsuite';
import CollaspedOutlineIcon from '@rsuite/icons/CollaspedOutline';
import ExpandOutlineIcon from '@rsuite/icons/ExpandOutline';
import { useDispatch, useSelector } from 'react-redux';
import { listNotifications } from '../actions/notificationActions ';

const audits = [
  {id: 1,
   doc_number: 'cda1279',
   name: "Ronald Kagwisagye",
   doc_type: "Death Certificate",
   last_modified: '2022-11-09 08:47:30',
   versions: [
    {
      version_number: 1,
      action: "Write",
      status: "success",
      date: '2022-11-09 08:47:30'
    },
    {
      version_number: 2,
      action: "Edit",
      status: "success",
      date: '2022-12-01 08:48:06'
    },

   ]
  },
   {id: 2,
   doc_number: 'cda1278',
   name: "Jean Bosco Mbuga",
   doc_type: "Death Application",
   last_modified: '2022-11-10 10:20:30',
   versions: [
    {
      version_number: 1,
      action: "Edit",
      status: "success",
      date: '2022-11-10 10:20:30'
    },

   ]
  },
  {id: 3,
   doc_number: 'cda1277',
   name: "Annet Naruweyiso",
   doc_type: "Death Application",
   last_modified: '2022-11-10 10:20:30',
   versions: [
    {
      version_number: 1,
      action: "Edit",
      status: "success",
      date: '2022-11-10 10:20:30'
    },
    {
      version_number: 2,
      action: "Edit",
      status: "success",
      date: '2022-12-01 08:48:06'
    }

   ]
  },

]

const { Column, HeaderCell, Cell } = Table;

const rowKey = 'id';

const ExpandCell = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
  <Cell {...props} style={{ padding: 5 }}>
    <IconButton
      appearance="subtle"
      onClick={() => {
        onChange(rowData);
      }}
      icon={
        expandedRowKeys.some(key => key === rowData[rowKey]) ? (
          <CollaspedOutlineIcon />
        ) : (
          <ExpandOutlineIcon />
        )
      }
    />
  </Cell>
);

const renderRowExpanded = rowData => {
  return (
    <div style={{paddingLeft: '50px', height: '150px'}} className="sub-not-container">
      <div className='sub-not-headers grid grid-4'>
        <p>Version</p>
        <p>Action</p>
        <p>Status</p>
        <p>Modification date</p>
      </div>
      {rowData.versions.map((version) => {
        return <div className="sub-not grid grid-4">
        <p>Ver. {version.version_number}</p>
        <p>{version.action}</p>
        <p>{version.status}</p>
        <p>{version.date}</p>


      </div>
      })}    
    </div>
  );
};

const AuditTableDeaths = () => {
const [sortColumn, setSortColumn] = React.useState();
const [sortType, setSortType] = React.useState();
const [loadingTable, setLoadingTable] = React.useState(false);

const dispatch = useDispatch()
const notificationList = useSelector((state) => state.notificationList)
const {loading, error, notifications} = notificationList
const userLogin = useSelector((state) => state.userLogin);
const { userInfo } = userLogin;

useEffect(() => {

    dispatch(listNotifications())

  }, [dispatch])

const getData = () => {
    if (sortColumn && sortType) {
      return audits.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === 'string') {
          x = x.charCodeAt();
        }
        if (typeof y === 'string') {
          y = y.charCodeAt();
        }
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return audits;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoadingTable(true);
    setTimeout(() => {
      setLoadingTable(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 300);
  };

  const [expandedRowKeys, setExpandedRowKeys] = React.useState([]);

  const handleExpanded = (rowData, dataKey) => {
    let open = false;
    const nextExpandedRowKeys = [];

    expandedRowKeys.forEach(key => {
      if (key === rowData[rowKey]) {
        open = true;
      } else {
        nextExpandedRowKeys.push(key);
      }
    });

    if (!open) {
      nextExpandedRowKeys.push(rowData[rowKey]);
    }

    setExpandedRowKeys(nextExpandedRowKeys);
  };

  // Pagination
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  };


  return (
    <Container>
        {notifications.success ? ( <Table
      shouldUpdateScroll={false} // Prevent the scrollbar from scrolling to the top after the table content area height changes.
      data={getData()}
      rowKey={rowKey}
      expandedRowKeys={expandedRowKeys}
      renderRowExpanded={renderRowExpanded}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={handleSortColumn}
      loading={loadingTable}
      autoHeight={true}
      cellBordered={false}
      virtualized={false}
      bordered
    >
      <Column width={70} align="center">
        <HeaderCell>...</HeaderCell>
        <ExpandCell dataKey="id" expandedRowKeys={expandedRowKeys} onChange={handleExpanded} />
      </Column>

      <Column width={250}>
        <HeaderCell>Document Id</HeaderCell>
        <Cell dataKey="doc_number" />
      </Column>
       <Column width={250} sortable>
        <HeaderCell>Name</HeaderCell>
        <Cell dataKey="name"/>
        
      </Column>

      <Column width={300}>
        <HeaderCell>Document Type</HeaderCell>
        <Cell dataKey="doc_type" />
      </Column>
       <Column width={300}>
        <HeaderCell>Date</HeaderCell>
        <Cell dataKey="last_modified" />
      </Column>
    </Table>): (<Loader/>)}
          {audits ? (<div className='table_pag' style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={['total', '-', 'limit', '|', 'pager', 'skip']}
          total={getData().length}
          limitOptions={[10, 30, 50]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>): (<Loader size="md" backdrop content="loading notifications..." vertical ></Loader>)}
        
    </Container>
    
  );
};

export default AuditTableDeaths